import React, {Component} from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'

export default class AllTwitterHandles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            copied: false
        }
    }

    handleCopy = () => {
        this.setState({copied: true});
    };

    componentWillReceiveProps(newProps) {
        if (this.props.handles !== newProps.handles) {
            this.setState({copied: false});
        }
    }

    render() {
        const buttonClass = `btn btn-sm ${this.state.copied ? 'btn-success' : 'btn-warning'}`;

        return (
            <tfoot>
                <tr>
                    <td style={{paddingTop: "25px"}}>
                        <label htmlFor="allTwitterHandles" style={{}}>Twitter handles:</label>
                        <input id="allTwitterHandles" type="text" value={this.props.handles} readOnly="readOnly"
                               style={{width: "100%", marginTop: "5px", marginBottom: "5px"}}/>
                        <CopyToClipboard text={this.props.handles} onCopy={this.handleCopy}>
                            <button className={buttonClass}>Copy to clipboard</button>
                        </CopyToClipboard>
                    </td>
                </tr>
            </tfoot>
        )
    }
}

AllTwitterHandles.propTypes = {
    handles: React.PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/dashboard/categories/AllTwitterHandles.js